var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatured(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 17.4",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15,5.5l-4.3-0.4l-1.7-4C8.8,0.9,8.6,0.8,8.4,0.9C8.4,0.9,8.3,1,8.3,1.1l-1.7,4L2.2,5.5C2,5.5,1.9,5.7,1.9,5.9 c0,0.1,0,0.2,0.1,0.2L5.3,9l-1,4.3c0,0.2,0.1,0.4,0.3,0.4c0.1,0,0.2,0,0.3,0l3.7-2.2l3.8,2.2c0.2,0.1,0.4,0,0.5-0.1 c0-0.1,0.1-0.2,0-0.3l-1-4.3l3.3-2.9c0.1-0.1,0.2-0.3,0-0.5C15.1,5.5,15.1,5.5,15,5.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M4.1,1C4.4,1.3,5,2.6,5.4,3.4c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0-0.1,0C4.5,2.9,3.5,1.9,3.3,1.6 C3.1,1.3,3.1,1,3.4,0.8C3.6,0.7,4,0.7,4.1,1L4.1,1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M13,1c-0.2,0.3-0.8,1.6-1.2,2.4c0,0.1,0,0.1,0.1,0.2c0,0,0.1,0,0.1,0c0.6-0.6,1.7-1.6,1.9-1.9 C14.1,1.3,14,1,13.8,0.8C13.5,0.7,13.2,0.7,13,1L13,1L13,1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M16.5,10c-0.4-0.1-1.8-0.3-2.6-0.4c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.7,0.4,2,1.1,2.4,1.2 c0.3,0.1,0.6-0.1,0.7-0.3C17,10.4,16.8,10.1,16.5,10L16.5,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M0.7,10C1,9.9,2.5,9.7,3.3,9.5c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.7,0.4-2,1.1-2.4,1.2 c-0.3,0.1-0.6-0.1-0.7-0.3C0.2,10.4,0.4,10.1,0.7,10L0.7,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M8.1,16.1c0-0.4,0.3-1.8,0.4-2.6c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1,0.1c0.2,0.8,0.4,2.3,0.4,2.6 c0,0.3-0.2,0.5-0.5,0.5C8.3,16.6,8.1,16.4,8.1,16.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M9.5,2.5L8.9,1.1C8.8,0.9,8.6,0.8,8.4,0.9C8.4,0.9,8.3,1,8.3,1.1l-1.7,4L2.2,5.5C2,5.5,1.9,5.7,1.9,5.9 c0,0.1,0,0.2,0.1,0.2L5.3,9l-1,4.3c0,0.2,0.1,0.4,0.3,0.4c0.1,0,0.2,0,0.3,0l0.5-0.3C5.9,9.5,7.4,5.8,9.5,2.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatured);
export default __webpack_public_path__ + "static/media/featured.556fd787.svg";
export { ForwardRef as ReactComponent };